/**
 * ISP Landing Page Animations
 * Uses GSAP + ScrollTrigger for scroll-driven animations.
 * Respects prefers-reduced-motion.
 */
(function () {
	"use strict";

	const prefersReducedMotion = window.matchMedia(
		"(prefers-reduced-motion: reduce)",
	).matches;
	if (prefersReducedMotion) {
		document.querySelectorAll(".isp-reveal").forEach(function (el) {
			el.style.opacity = "1";
			el.style.transform = "none";
		});
		return;
	}

	if (typeof gsap === "undefined" || typeof ScrollTrigger === "undefined") {
		return;
	}

	gsap.registerPlugin(ScrollTrigger, SplitText, DrawSVGPlugin);

	var DURATION = 0.55;
	var EASE = "power2.out";
	var STAGGER = 0.15;
	var START = "top 75%";
	var TOGGLE = "play none none none";

	// Set to false to disable pinning on the technology section.
	var TECHNOLOGY_PIN = false;

	var IS_MOBILE = window.matchMedia("(max-width: 767px)").matches;

	// Set to false to disable the stats → needs background crossfade.
	var BG_COLOR_SHIFT = true;

	function initReveals() {
		document.querySelectorAll(".isp-reveal-group").forEach(function (group) {
			var els = [].slice.call(group.children);
			if (els.length === 0) return;
			gsap.from(els, {
				opacity: 0,
				y: 80,
				duration: DURATION,
				ease: EASE,
				stagger: STAGGER,
				scrollTrigger: {
					trigger: group,
					start: START,
					toggleActions: TOGGLE,
				},
			});
		});

		document.querySelectorAll(".isp-reveal").forEach(function (el) {
			if (
				el.classList.contains("isp-reveal-group") ||
				el.closest(".isp-reveal-group")
			)
				return;
			gsap.from(el, {
				opacity: 0,
				y: 80,
				duration: DURATION,
				ease: EASE,
				scrollTrigger: {
					trigger: el,
					start: START,
					toggleActions: TOGGLE,
				},
			});
		});
	}

	function initStatsNeeds() {
		var wrapper = document.querySelector(".isp-stats-needs");
		if (!wrapper) return;

		var statsZone = wrapper.querySelector(".isp-stats-needs__stats");
		var twoNeedsZone = wrapper.querySelector(".isp-stats-needs__two-needs");

		// --- Background layers ---
		var bgLight = wrapper.querySelector(".isp-stats-needs__bg-light");
		if (BG_COLOR_SHIFT && bgLight && twoNeedsZone) {
			gsap.set(bgLight, { opacity: 0 });
			if (statsZone) {
				gsap.set(statsZone, { autoAlpha: 1 });
			}

			ScrollTrigger.create({
				trigger: twoNeedsZone,
				start: "top 75%",
				onEnter: function () {
					gsap.to(bgLight, {
						opacity: 1,
						duration: 0.7,
						ease: "power2.inOut",
						overwrite: true,
					});
					if (statsZone) {
						gsap.to(statsZone, {
							autoAlpha: 0,
							duration: 0.45,
							ease: "power2.out",
							overwrite: true,
						});
					}
				},
				onEnterBack: function () {
					gsap.to(bgLight, {
						opacity: 1,
						duration: 0.45,
						ease: "power2.inOut",
						overwrite: true,
					});
					if (statsZone) {
						gsap.to(statsZone, {
							autoAlpha: 0,
							duration: 0.3,
							ease: "power2.out",
							overwrite: true,
						});
					}
				},
				onLeaveBack: function () {
					gsap.to(bgLight, {
						opacity: 0,
						duration: 0.7,
						ease: "power2.inOut",
						overwrite: true,
					});
					if (statsZone) {
						gsap.to(statsZone, {
							autoAlpha: 1,
							duration: 0.45,
							ease: "power2.out",
							overwrite: true,
						});
					}
				},
			});
		}

		// --- Stats: headline fade up (Template 2: Top → In) ---
		var statsHeader = wrapper.querySelector(".isp-stats__header");
		var headline = statsHeader
			? statsHeader.querySelector(".isp-stats__headline")
			: null;
		var subhead = statsHeader
			? statsHeader.querySelector(".isp-stats__subhead")
			: null;

		if (headline) {
			SplitText.create(headline, {
				type: "lines",
				linesClass: "isp-split-line",
				autoSplit: true,
				onSplit: function (self) {
					gsap.set(headline, { autoAlpha: 1 });
					return gsap.from(self.lines, {
						autoAlpha: 0,
						y: 80,
						duration: 0.8,
						ease: "power3.out",
						stagger: { each: 0.15 },
						scrollTrigger: {
							trigger: statsHeader,
							start: "top 75%",
							toggleActions: TOGGLE,
						},
					});
				},
			});
		}

		if (subhead) {
			gsap.from(subhead, {
				autoAlpha: 0,
				y: 80,
				duration: 0.8,
				ease: "power3.out",
				delay: 0.2,
				scrollTrigger: {
					trigger: statsHeader,
					start: "top 75%",
					toggleActions: TOGGLE,
				},
			});
		}

		// --- Stats: staggered items reveal + counter start on fade-in ---
		var statItems = wrapper.querySelectorAll(".isp-stats__item");
		var statsRow = wrapper.querySelector(".isp-stats__row");
		var statDiv = wrapper.querySelectorAll(".isp-stats__divider");
		if (statItems.length) {
			gsap.from(statItems, {
				autoAlpha: 0,
				y: 80,
				duration: 0.6,
				ease: "power3.out",
				stagger: {
					each: 0.15,
					onStart: function () {
						var numberEl = this.targets()[0].querySelector(
							".isp-stat__number[data-target]",
						);
						if (!numberEl) return;
						numberEl.textContent = "0";
						var target = parseFloat(numberEl.getAttribute("data-target"));
						var obj = { val: 0 };
						gsap.to(obj, {
							val: target,
							duration: 3.5,
							ease: "circ.out",
							snap: { val: 1 },
							onUpdate: function () {
								numberEl.textContent = Math.round(obj.val);
							},
						});
					},
				},
				scrollTrigger: {
					trigger: statsRow,
					start: "top 75%",
					toggleActions: TOGGLE,
				},
			});

			gsap.from(statDiv, {
				autoAlpha: 0,
				duration: 0.8,
				ease: "power3.out",
				scrollTrigger: {
					trigger: statsRow,
					start: "top 75%",
					toggleActions: TOGGLE,
				},
			});
		}

		// --- Two Needs: sequenced entry animations ---
		if (twoNeedsZone) {
			var tnHeadline = twoNeedsZone.querySelector(".isp-two-needs__headline");
			var tnSubhead = twoNeedsZone.querySelector(".isp-two-needs__subhead");
			var leftOutline = twoNeedsZone.querySelector(
				".isp-two-needs__column--left .isp-two-needs__circle-outline",
			);
			var rightOutline = twoNeedsZone.querySelector(
				".isp-two-needs__column--right .isp-two-needs__circle-outline",
			);
			var leftFill = twoNeedsZone.querySelector(
				".isp-two-needs__column--left .isp-two-needs__circle-fill",
			);
			var rightFill = twoNeedsZone.querySelector(
				".isp-two-needs__column--right .isp-two-needs__circle-fill",
			);
			var leftCol = twoNeedsZone.querySelectorAll(
				".isp-two-needs__column--left .isp-two-needs__column-title, .isp-two-needs__column--left .isp-two-needs__column-bullets",
			);
			var rightCol = twoNeedsZone.querySelectorAll(
				".isp-two-needs__column--right .isp-two-needs__column-title, .isp-two-needs__column--right .isp-two-needs__column-bullets",
			);
			var centerCol = twoNeedsZone.querySelector(".isp-two-needs__center");

			var tnTl = gsap.timeline({
				scrollTrigger: {
					trigger: twoNeedsZone,
					start: "top 75%",
					toggleActions: TOGGLE,
				},
			});

			// 1. Headline: SplitText lines stagger fade up (responsive)
			if (tnHeadline) {
				SplitText.create(tnHeadline, {
					type: "lines",
					linesClass: "isp-split-line",
					autoSplit: true,
					onSplit: function (self) {
						gsap.set(tnHeadline, { autoAlpha: 1 });
						return gsap.from(self.lines, {
							autoAlpha: 0,
							y: 80,
							duration: DURATION,
							ease: EASE,
							stagger: { each: 0.15 },
							scrollTrigger: {
								trigger: twoNeedsZone,
								start: "top 75%",
								toggleActions: TOGGLE,
							},
						});
					},
				});
			}

			// 2. Subhead: SplitText lines stagger fade up (responsive)
			if (tnSubhead) {
				// Wrap non-breaking-space-joined words in spans so SplitText
				// treats them as a single token and won't split across them.
				tnSubhead.innerHTML = tnSubhead.innerHTML.replace(
					/(\S+)(?:\u00A0|&nbsp;)(\S+)/g,
					'<span style="white-space:nowrap">$1\u00A0$2</span>',
				);
				SplitText.create(tnSubhead, {
					type: "lines",
					linesClass: "isp-split-line",
					autoSplit: true,
					onSplit: function (self) {
						gsap.set(tnSubhead, { autoAlpha: 1 });
						return gsap.from(self.lines, {
							autoAlpha: 0,
							y: 80,
							duration: DURATION,
							ease: EASE,
							stagger: { each: 0.15 },
							delay: DURATION * 0.6,
							scrollTrigger: {
								trigger: twoNeedsZone,
								start: "top 75%",
								toggleActions: TOGGLE,
							},
						});
					},
				});
			}

			// Position the circles label to account for text animation duration
			tnTl.addLabel("circles", 1.2);

			// 3. Left outline: fade in + rotate 360 clockwise
			if (leftOutline) {
				gsap.set(leftOutline, { opacity: 0, rotation: -360 });
				tnTl.to(
					leftOutline,
					{
						opacity: 1,
						rotation: 0,
						duration: 2,
						ease: "expo.out",
						transformOrigin: "center center",
					},
					"circles",
				);
			}

			// 4. Right outline: fade in + rotate 360 counter-clockwise
			if (rightOutline) {
				gsap.set(rightOutline, { opacity: 0, rotation: 360, scaleX: -1 });
				tnTl.to(
					rightOutline,
					{
						opacity: 1,
						rotation: 0,
						scaleX: -1,
						duration: 2,
						ease: "expo.out",
						transformOrigin: "center center",
					},
					"circles+=0.4",
				);
			}

			// 5. Left gradient fill: fade in + rotate 360 clockwise
			if (leftFill) {
				gsap.set(leftFill, { opacity: 0, rotation: -360 });
				tnTl.to(
					leftFill,
					{
						opacity: 1,
						rotation: 0,
						duration: 2,
						ease: "expo.out",
						transformOrigin: "center center",
					},
					"circles+=0.8",
				);
			}

			// 6. Right gradient fill: fade in + rotate 360 counter-clockwise
			if (rightFill) {
				gsap.set(rightFill, { opacity: 0, rotation: 360 });
				tnTl.to(
					rightFill,
					{
						opacity: 1,
						rotation: 0,
						duration: 2,
						ease: "expo.out",
						transformOrigin: "center center",
					},
					"circles+=1.2",
				);
			}

			// 7. Left text: fade in
			if (leftCol.length) {
				tnTl.from(
					leftCol,
					{
						opacity: 0,
						duration: DURATION,
						ease: EASE,
					},
					"circles+=1.6",
				);
			}

			// 8. Right text: fade in
			if (rightCol.length) {
				tnTl.from(
					rightCol,
					{
						opacity: 0,
						duration: DURATION,
						ease: EASE,
					},
					"circles+=2",
				);
			}

			// 9. Center logo: fade in
			if (centerCol) {
				tnTl.from(
					centerCol,
					{
						opacity: 0,
						duration: DURATION,
						ease: EASE,
					},
					"circles+=2.4",
				);
			}

			// --- Merge (final steps of entry timeline) ---
			var leftCircleWrap = twoNeedsZone.querySelector(
				".isp-two-needs__column--left .isp-two-needs__circle",
			);
			var rightCircleWrap = twoNeedsZone.querySelector(
				".isp-two-needs__column--right .isp-two-needs__circle",
			);
			var columnsWrap = twoNeedsZone.querySelector(".isp-two-needs__columns");

			if (leftCircleWrap && rightCircleWrap && columnsWrap) {
				// Compute how far each circle must travel to reach the horizontal center
				var colsRect = columnsWrap.getBoundingClientRect();
				var colsCenterX = colsRect.left + colsRect.width / 2;
				var leftRect = leftCircleWrap.getBoundingClientRect();
				var leftDx = colsCenterX - (leftRect.left + leftRect.width / 2);
				var rightRect = rightCircleWrap.getBoundingClientRect();
				var rightDx = colsCenterX - (rightRect.left + rightRect.width / 2);

				// 10. Merge label — starts after venn diagram is fully visible
				tnTl.addLabel("merge", "circles+=3.2");

				// 11. Fade out column text + outlines
				if (leftCol.length)
					tnTl.to(
						leftCol,
						{ opacity: 0, duration: 0.3, ease: "power2.in" },
						"merge",
					);
				if (rightCol.length)
					tnTl.to(
						rightCol,
						{ opacity: 0, duration: 0.3, ease: "power2.in" },
						"merge",
					);
				if (leftOutline)
					tnTl.to(leftOutline, { opacity: 0, duration: 0.25 }, "merge+=0.05");
				if (rightOutline)
					tnTl.to(rightOutline, { opacity: 0, duration: 0.25 }, "merge+=0.05");

				// 12. Slide circles to overlap at the center (fills stay visible)
				tnTl.to(
					leftCircleWrap,
					{ x: leftDx, duration: 0.6, ease: "power2.inOut" },
					"merge+=0.15",
				);
				tnTl.to(
					rightCircleWrap,
					{ x: rightDx, duration: 0.6, ease: "power2.inOut" },
					"merge+=0.15",
				);

				// 13. Scale up center logo after circles merge
				if (centerCol)
					tnTl.to(
						centerCol,
						{
							scale: 2,
							duration: 0.4,
							ease: "back.out(1.7)",
						},
						"merge+=0.55",
					);

				// --- Unmerge (plays automatically after the merge, following a short hold) ---
				// Merge finishes around merge+=0.95; hold the merged state briefly.
				tnTl.addLabel("unmerge", "merge+=1.6");

				// 14. Shrink center logo back to normal
				if (centerCol)
					tnTl.to(
						centerCol,
						{ scale: 1, duration: 0.3, ease: "power2.in" },
						"unmerge",
					);

				// 15. Circles slide apart
				tnTl.to(
					leftCircleWrap,
					{ x: 0, duration: 0.6, ease: "power2.inOut" },
					"unmerge+=0.15",
				);
				tnTl.to(
					rightCircleWrap,
					{ x: 0, duration: 0.6, ease: "power2.inOut" },
					"unmerge+=0.15",
				);

				// 16. Text + outlines fade back in
				if (leftOutline)
					tnTl.to(
						leftOutline,
						{ opacity: 1, duration: 0.25 },
						"unmerge+=0.4",
					);
				if (rightOutline)
					tnTl.to(
						rightOutline,
						{ opacity: 1, duration: 0.25 },
						"unmerge+=0.4",
					);
				if (leftCol.length)
					tnTl.to(leftCol, { opacity: 1, duration: 0.3 }, "unmerge+=0.5");
				if (rightCol.length)
					tnTl.to(rightCol, { opacity: 1, duration: 0.3 }, "unmerge+=0.5");
			}
		}
	}

	function initProductFeatures() {
		var section = document.querySelector(".isp-features");
		if (!section) return;

		// --- Entry animations ---
		var header = section.querySelector(".isp-features__header");
		var headline = header
			? header.querySelector(".isp-features__headline")
			: null;
		var subhead = header
			? header.querySelector(".isp-features__subhead")
			: null;

		if (header) {
			// Headline: basic fade up; subhead: SplitText lines stagger in after
			var headerTl = gsap.timeline({
				scrollTrigger: { trigger: header, start: START, toggleActions: TOGGLE },
			});

			if (headline) {
				headerTl.from(headline, {
					opacity: 0,
					y: 80,
					duration: DURATION,
					ease: EASE,
				});
			}

			if (subhead) {
				SplitText.create(subhead, {
					type: "lines",
					linesClass: "isp-split-line",
					autoSplit: true,
					onSplit: function (self) {
						gsap.set(subhead, { autoAlpha: 1 });
						return gsap.from(self.lines, {
							autoAlpha: 0,
							y: 80,
							duration: DURATION,
							ease: EASE,
							stagger: { each: STAGGER },
							delay: DURATION * 0.6,
							scrollTrigger: {
								trigger: header,
								start: START,
								toggleActions: TOGGLE,
							},
						});
					},
				});
			}
		}

		var desktopBody = section.querySelector(".isp-features__body--desktop");
		var mobileBody = section.querySelector(".isp-features__body--mobile");

		var FADE_DURATION = 0.3;

		// --- Mobile only: scroll-driven letters + image cycling (no pinning) ---
		if (IS_MOBILE && mobileBody) {
			var mobileImageWrap = mobileBody.querySelector(
				".isp-features__image-wrap",
			);
			if (mobileImageWrap) {
				gsap.from(mobileImageWrap, {
					opacity: 0,
					y: 80,
					duration: DURATION,
					ease: EASE,
					scrollTrigger: {
						trigger: mobileImageWrap,
						start: START,
						toggleActions: TOGGLE,
					},
				});
			}

			var mobileItems = [].slice.call(
				mobileBody.querySelectorAll(".isp-features__item"),
			);
			var mobileSlides = mobileImageWrap
				? [].slice.call(
						mobileImageWrap.querySelectorAll(".isp-features__slide"),
					)
				: [];
			var mobileRow = mobileBody.querySelector(".isp-features__row");

			// I.S.P. letters are blue from the start (set in Liquid/CSS) — only cycle images on scroll
			if (mobileSlides.length >= 2 && mobileItems.length) {
				var mobileSlideSegment = -1;

				function setMobileSlideSegment(idx) {
					if (idx === mobileSlideSegment) return;
					mobileSlideSegment = idx;

					mobileSlides.forEach(function (slide, si) {
						gsap.to(slide, {
							opacity: si === idx ? 1 : 0,
							duration: FADE_DURATION,
							ease: EASE,
							overwrite: true,
						});
					});
				}

				gsap.set(mobileSlides[0], { opacity: 1 });
				gsap.set(mobileSlides.slice(1), { opacity: 0 });
				setMobileSlideSegment(0);

				mobileItems.forEach(function (item, idx) {
					ScrollTrigger.create({
						trigger: item,
						start: "top bottom",
						end: "bottom bottom",
						onEnter: function () {
							setMobileSlideSegment(idx);
						},
						onEnterBack: function () {
							setMobileSlideSegment(idx > 0 ? idx - 1 : 0);
						},
					});
				});
			}

			if (mobileItems.length) {
				gsap.from(mobileItems, {
					opacity: 0,
					y: 80,
					duration: DURATION,
					ease: EASE,
					stagger: STAGGER,
					scrollTrigger: {
						trigger: mobileRow || mobileItems[0],
						start: START,
						toggleActions: TOGGLE,
					},
				});
			}
			return;
		}

		// --- Desktop only below ---

		// Image wrap: basic fade up (whole wrap, not individual images)
		var imageWrap = desktopBody
			? desktopBody.querySelector(".isp-features__image-wrap")
			: section.querySelector(".isp-features__image-wrap");
		if (imageWrap) {
			gsap.from(imageWrap, {
				opacity: 0,
				y: 80,
				duration: DURATION,
				ease: EASE,
				scrollTrigger: {
					trigger: imageWrap,
					start: START,
					toggleActions: TOGGLE,
				},
			});
		}

		var slides = desktopBody
			? [].slice.call(desktopBody.querySelectorAll(".isp-features__slide"))
			: [];
		var isPinned = slides.length >= 2;

		if (!isPinned) {
			var items = desktopBody
				? [].slice.call(desktopBody.querySelectorAll(".isp-features__item"))
				: [];
			if (items.length) {
				gsap.from(items, {
					opacity: 0,
					y: 80,
					duration: DURATION,
					ease: EASE,
					stagger: STAGGER,
					scrollTrigger: {
						trigger: desktopBody
							? desktopBody.querySelector(".isp-features__row")
							: items[0],
						start: START,
						toggleActions: TOGGLE,
					},
				});
			}
			return;
		}

		var items = desktopBody
			? [].slice.call(desktopBody.querySelectorAll(".isp-features__item"))
			: [];

		// Pinned mode: slide 0 visible, rest hidden
		gsap.set(slides[0], { opacity: 1 });
		gsap.set(slides.slice(1), { opacity: 0 });

		// Wrap each item so the entry animation (opacity/y on the wrapper) is fully
		// isolated from the scrub (opacity on the item itself).
		var itemWraps = items.map(function (item) {
			var wrap = document.createElement("div");
			wrap.className = "isp-features__item-wrap";
			item.parentNode.insertBefore(wrap, item);
			wrap.appendChild(item);
			return wrap;
		});

		// Items start at 0.3 opacity (dimmed). Scrub will promote the active one to 1.
		gsap.set(items, { opacity: 0.3 });

		// Entry: fade wrappers up — lands at opacity 1, y 0 — item opacity untouched.
		if (itemWraps.length) {
			gsap.from(itemWraps, {
				opacity: 0,
				y: 80,
				duration: DURATION,
				ease: EASE,
				stagger: STAGGER,
				scrollTrigger: {
					trigger: desktopBody
						? desktopBody.querySelector(".isp-features__row")
						: section,
					start: START,
					toggleActions: TOGGLE,
				},
			});
		}

		// Segment-based snap: one scroll segment per slide — fade transition, no overlap
		var END_BUFFER = window.innerHeight * 1; // extra scroll after last slide before unpin
		var contentRange = (slides.length - 1) * window.innerHeight;
		var totalScrollRange = contentRange + END_BUFFER;
		// Ratio of total scroll that holds actual content transitions
		var contentRatio = contentRange / totalScrollRange;
		var snapPoints = slides.map(function (_, i) {
			return slides.length === 1 ? 0 : (i / (slides.length - 1)) * contentRatio;
		});
		// Also snap to the very end so the buffer zone resolves cleanly
		snapPoints.push(1);

		var activeSegment = -1;
		function showSegment(idx) {
			if (idx === activeSegment) return;
			activeSegment = idx;

			// Fade all slides: only the active one fades in, others fade out
			// overwrite:true cancels any in-flight tween so fast scrolling always lands correctly
			slides.forEach(function (slide, si) {
				gsap.to(slide, {
					opacity: si === idx ? 1 : 0,
					duration: FADE_DURATION,
					ease: EASE,
					overwrite: true,
				});
			});

			items.forEach(function (item, ii) {
				// Only the active item should be fully opaque; others stay dimmed
				gsap.to(item, {
					opacity: ii === idx ? 1 : 0.3,
					duration: FADE_DURATION,
					ease: EASE,
					overwrite: true,
				});
			});

			// I.S.P. letters stay blue throughout (set in Liquid/CSS) — no scroll toggle
		}
		showSegment(0);

		ScrollTrigger.create({
			trigger: section,
			pin: true,
			start: "center center",
			end: "+=" + totalScrollRange,
			snap: {
				snapTo: snapPoints,
				duration: { min: 0.3, max: 0.6 },
				ease: "power1.inOut",
			},
			onUpdate: function (self) {
				// Map progress within the content portion only; buffer keeps last slide visible
				var p = Math.min(self.progress / contentRatio, 1);
				var idx = Math.round(p * (slides.length - 1));
				showSegment(idx);
			},
		});
	}

	function initCta() {
		var section = document.querySelector(".isp-cta");
		if (!section) return;

		var headline = section.querySelector(".isp-cta__headline");
		var subhead = section.querySelector(".isp-cta__subhead");
		var button = section.querySelector(".isp-cta__button");

		var els = [headline, subhead, button].filter(Boolean);
		if (!els.length) return;

		gsap.from(els, {
			opacity: 0,
			y: 80,
			duration: DURATION,
			ease: EASE,
			stagger: STAGGER,
			scrollTrigger: {
				trigger: section,
				start: START,
				toggleActions: TOGGLE,
			},
		});
	}

	// ---------------------------------------------------------------------------
	// Orb intensity multiplier — raise this to increase the pulse scale range.
	// 1.0 = gentle pulse; 2.0 = strong pulse.
	// Orbit path is deterministic CSS — only the scale pulsing is random.
	// ---------------------------------------------------------------------------
	var ORB_INTENSITY = 1.0;

	function initTechnologyOrbs() {
		if (IS_MOBILE || prefersReducedMotion) return;

		var el = document.querySelector(".isp-technology__bg-gradient");
		if (!el) return;

		var MAX_SCALE = 0.08 * ORB_INTENSITY; // max scale variation (±)

		function rand(min, max) {
			return +(Math.random() * (max - min) + min).toFixed(3);
		}

		function pulseOrbA() {
			el.style.setProperty("--orb-a-s", rand(1 - MAX_SCALE, 1 + MAX_SCALE));
			setTimeout(pulseOrbA, rand(3000, 7000));
		}

		function pulseOrbB() {
			el.style.setProperty("--orb-b-s", rand(1 - MAX_SCALE, 1 + MAX_SCALE));
			setTimeout(pulseOrbB, rand(4000, 9000));
		}

		// Stagger B by 2 s so the two orbs never pulse in sync.
		pulseOrbA();
		setTimeout(pulseOrbB, 2000);
	}

	function initTechnology() {
		var section = document.querySelector(".isp-technology");
		if (!section) return;

		// --- Ambient pulse rings (controlled by stepper highlight state) ---
		var pulseEls = section.querySelectorAll(".isp-wrt__pulse");
		var pulseTl = null;
		if (!IS_MOBILE && pulseEls.length > 0) {
			pulseTl = gsap.timeline({ paused: true, repeat: -1 });
			pulseEls.forEach(function (el, i) {
				pulseTl.fromTo(
					el,
					{ scale: 0.8, opacity: 0.5 },
					{ scale: 2.4, opacity: 0, duration: 3.5, ease: "power2.out" },
					i * 1.75,
				);
			});
		}

		// --- Align stepper nodes with content items + build gapped track gradients ---
		// Must run BEFORE gsap.from() calls so items are still at their natural positions
		var overlay = section.querySelector(".isp-technology__stepper-overlay");
		var progress = section.querySelector(".isp-technology__stepper-progress");
		var allItems = [].slice.call(
			section.querySelectorAll(".isp-technology__item"),
		);

		var dimNodes = [];
		var brightNodes = [];
		if (overlay) {
			for (var c = 0; c < overlay.children.length; c++) {
				if (
					overlay.children[c].classList.contains("isp-technology__stepper-node")
				) {
					dimNodes.push(overlay.children[c]);
				}
			}
		}
		if (progress) {
			brightNodes = [].slice.call(
				progress.querySelectorAll(".isp-technology__stepper-node"),
			);
		}
		var dimTrack = overlay
			? overlay.querySelector(".isp-technology__stepper-track--dim")
			: null;
		var brightTrack = overlay
			? overlay.querySelector(".isp-technology__stepper-track--bright")
			: null;

		function buildTrackGradient(color, centers) {
			var stops = [];
			var prev = 0;
			centers.forEach(function (c) {
				stops.push(color + " " + prev + "px");
				stops.push(color + " " + (c - 21) + "px");
				stops.push("transparent " + (c - 21) + "px");
				stops.push("transparent " + (c + 21) + "px");
				prev = c + 21;
			});
			stops.push(color + " " + prev + "px");
			stops.push(color + " 100%");
			return "linear-gradient(to bottom, " + stops.join(", ") + ")";
		}

		function alignStepper() {
			if (!overlay || !allItems.length) return;
			var overlayRect = overlay.getBoundingClientRect();
			var centers = allItems.map(function (item) {
				var r = item.getBoundingClientRect();
				return r.top + r.height / 2 - overlayRect.top;
			});
			centers.forEach(function (cx, i) {
				if (dimNodes[i]) dimNodes[i].style.top = cx + "px";
				if (brightNodes[i]) brightNodes[i].style.top = cx + "px";
			});
			if (dimTrack)
				dimTrack.style.background = buildTrackGradient(
					"rgba(148, 216, 255, 0.15)",
					centers,
				);
			if (brightTrack)
				brightTrack.style.background = buildTrackGradient("#94d8ff", centers);
		}

		if (!IS_MOBILE) {
			alignStepper();
			window.addEventListener("resize", alignStepper);
		}

		// --- Entry: left column fade up ---
		var leftCol = section.querySelector(".isp-technology__left");
		if (leftCol) {
			gsap.from(leftCol, {
				opacity: 0,
				y: 80,
				duration: DURATION,
				ease: EASE,
				scrollTrigger: {
					trigger: section,
					start: START,
					toggleActions: TOGGLE,
				},
			});
		}

		// --- Entry: item content ---
		var itemContents = [].slice.call(
			section.querySelectorAll(".isp-technology__item-content"),
		);
		if (!itemContents.length) return;

		var isMobile = window.matchMedia("(max-width: 767px)").matches;

		if (isMobile) {
			// Mobile: standard stagger fade up on scroll
			gsap.from(itemContents, {
				opacity: 0,
				y: 80,
				duration: DURATION,
				ease: EASE,
				stagger: STAGGER,
				scrollTrigger: {
					trigger: section.querySelector(".isp-technology__right"),
					start: START,
					toggleActions: TOGGLE,
				},
			});
		} else {
			// Desktop: fade in as highlight reaches each number
			gsap.set(itemContents, { opacity: 0 }); // Start at 0 for scroll-driven reveal

			// --- Scroll-driven stepper: clip-path reveals bright track + circles ---
			if (!progress) return;

			var stepperTl = gsap.timeline();
			stepperTl.fromTo(
				progress,
				{ clipPath: "inset(0 0 100% 0)" },
				{ clipPath: "inset(0 0 0% 0)", ease: "none", duration: 1 },
			);

			// Calculate each brightNode's position as % from bottom of progress element
			var nodePositions = brightNodes.map(function (node) {
				var nodeRect = node.getBoundingClientRect();
				var progressRect = progress.getBoundingClientRect();
				// Distance from node to bottom of progress, as percentage
				var distanceFromBottom = progressRect.bottom - nodeRect.top;
				var progressHeight = progressRect.height;
				return (distanceFromBottom / progressHeight) * 100;
			});

			// Scroll distance while pinned — gives each item ~70 vh to reveal
			var scrollDist = allItems.length * Math.round(window.innerHeight * 0.7);

			var scrollTriggerInstance = ScrollTrigger.create({
				trigger: section,
				animation: stepperTl,
				pin: TECHNOLOGY_PIN,
				start: TECHNOLOGY_PIN ? "center center" : "top center",
				end: TECHNOLOGY_PIN ? "+=" + scrollDist : "bottom center",
				scrub: 1,
				onUpdate: function (self) {
					var scrollProgress = self.progress;
					// clip-path inset goes from 100% to 0%, so current inset is 100 - (100 * progress)
					var currentInset = 100 - scrollProgress * 100;
					var anyHighlighted = false;

					itemContents.forEach(function (item, index) {
						// Already fully revealed — count as highlighted
						if (item.getAttribute("data-revealed") === "true") {
							anyHighlighted = true;
							return;
						}

						var nodePos = nodePositions[index];
						// Fade in when clip-path reaches the node (inset value drops below node position)
						// Use a 5% window for smooth fade
						var fadeStartInset = nodePos + 5;
						var fadeEndInset = nodePos - 5;

						var isRevealing = currentInset <= fadeStartInset;
						var isFadingIn =
							currentInset <= fadeStartInset && currentInset >= fadeEndInset;

						// Mark as revealed when fully shown
						if (isRevealing && currentInset <= fadeEndInset) {
							item.setAttribute("data-revealed", "true");
							gsap.set(item, { opacity: 1 });
							anyHighlighted = true;
						} else if (isFadingIn) {
							// Animate from 0 to 1 as inset goes from fadeStartInset to fadeEndInset
							var itemOpacity =
								1 -
								(currentInset - fadeEndInset) / (fadeStartInset - fadeEndInset);
							gsap.set(item, { opacity: itemOpacity });
							anyHighlighted = true;
						}
					});

					// Pulse rings play only while a number is highlighted
					if (pulseTl) {
						if (anyHighlighted) {
							if (!pulseTl.isActive()) pulseTl.play();
						} else {
							pulseTl.pause();
						}
					}
				},
				onLeave: function () {
					if (pulseTl) pulseTl.pause();
				},
				onLeaveBack: function () {
					if (pulseTl) pulseTl.pause();
				},
			});
		}
	}

	function initPlatforms() {
		var section = document.querySelector(".isp-platforms");
		if (!section) return;

		var headline = section.querySelector(".isp-platforms__headline");
		var cols = [].slice.call(section.querySelectorAll(".isp-platforms__col"));
		var assetWrap = section.querySelector(".isp-platforms__asset-wrap");
		var lottiePlayer = section.querySelector(
			".isp-platforms__asset-desktop .isp-platforms__lottie",
		);
		var isLottie = !!lottiePlayer;

		// --- Set initial hidden states immediately to prevent flash ---
		if (headline) {
			SplitText.create(headline, {
				type: "lines",
				linesClass: "isp-split-line",
				autoSplit: true,
				onSplit: function (self) {
					gsap.set(headline, { autoAlpha: 1 });
					return gsap.from(self.lines, {
						autoAlpha: 0,
						y: 80,
						duration: DURATION,
						ease: EASE,
						stagger: { each: STAGGER },
						scrollTrigger: {
							trigger: headline,
							start: START,
							toggleActions: TOGGLE,
						},
					});
				},
			});
		}
		if (assetWrap) {
			gsap.set(assetWrap, { opacity: 0 });
		}

		var hasMobileAsset =
			assetWrap &&
			assetWrap.classList.contains("isp-platforms__asset-wrap--has-mobile");
		var isPinned = cols.length > 1 && !IS_MOBILE;

		// --- Entry animations (headline + asset) ---
		if (assetWrap) {
			ScrollTrigger.create({
				trigger: assetWrap,
				start: START,
				once: true,
				onEnter: function () {
					gsap.to(assetWrap, { opacity: 1, duration: DURATION, ease: EASE });
				},
			});
		}

		// =============== Mobile / non-pinned ===============
		if (!isPinned) {
			if (cols.length) {
				gsap.set(cols, { opacity: 0, y: 80 });
				ScrollTrigger.create({
					trigger: section.querySelector(".isp-platforms__columns"),
					start: START,
					once: true,
					onEnter: function () {
						gsap.to(cols, {
							opacity: 1,
							y: 0,
							duration: DURATION,
							ease: EASE,
							stagger: { each: STAGGER },
						});
					},
				});
			}

			// Lottie scrub for mobile (keep existing non-pinned approach)
			if (isLottie && !(IS_MOBILE && hasMobileAsset)) {
				var lottieScrollTrigger = section;
				var lottieStart = "center bottom";
				var lottieEnd = "bottom+=" + window.innerHeight * 0.5 + "px bottom";

				function setupLottieScrubMobile() {
					var totalFrames = lottiePlayer.getLottie().totalFrames;
					if (!totalFrames) return;

					var targetFrame = 0;
					var currentFrame = 0;
					var rafId = null;
					var LERP = 0.12;
					var THRESHOLD = 0.5;

					function tick() {
						currentFrame += (targetFrame - currentFrame) * LERP;
						var clamped = Math.max(0, Math.min(totalFrames - 1, currentFrame));
						if (
							Math.abs(clamped - lottiePlayer.getLottie().currentFrame) >
							THRESHOLD
						) {
							lottiePlayer.seek(Math.round(clamped));
						}
						if (Math.abs(targetFrame - currentFrame) > THRESHOLD) {
							rafId = requestAnimationFrame(tick);
						} else {
							rafId = null;
						}
					}

					function ensureLoop() {
						if (!rafId) rafId = requestAnimationFrame(tick);
					}

					ScrollTrigger.create({
						trigger: lottieScrollTrigger,
						start: lottieStart,
						end: lottieEnd,
						onUpdate: function (self) {
							var p = Math.min(self.progress / 0.9, 1);
							targetFrame = p * (totalFrames - 1);
							ensureLoop();
						},
						onLeave: function () {
							targetFrame = totalFrames - 1;
							currentFrame = totalFrames - 1;
							lottiePlayer.seek(totalFrames - 1);
							if (rafId) {
								cancelAnimationFrame(rafId);
								rafId = null;
							}
						},
						onLeaveBack: function () {
							targetFrame = 0;
							currentFrame = 0;
							lottiePlayer.seek(0);
							if (rafId) {
								cancelAnimationFrame(rafId);
								rafId = null;
							}
						},
					});
				}

				lottiePlayer.addEventListener("ready", function () {
					lottiePlayer.pause();
					lottiePlayer.seek(0);
					setupLottieScrubMobile();
				});
			}

			return;
		}

		// =============== Desktop pinned mode ===============
		// Columns cycle one-by-one; lottie scrubs in sync.

		// Initial col states: first visible, rest hidden
		gsap.set(cols[0], { opacity: 1 });
		gsap.set(cols.slice(1), { opacity: 0 });

		var FADE_DURATION = 0.3;
		var activeCol = -1;

		function showColumn(idx) {
			if (idx === activeCol) return;
			activeCol = idx;
			cols.forEach(function (col, ci) {
				gsap.to(col, {
					opacity: ci === idx ? 1 : 0,
					duration: FADE_DURATION,
					ease: EASE,
					overwrite: true,
				});
			});
		}
		showColumn(0);

		// Scroll range: one viewport-height per column transition, plus a buffer
		var END_BUFFER = window.innerHeight * 0.5;
		var contentRange = (cols.length - 1) * window.innerHeight;
		var totalScrollRange = contentRange + END_BUFFER;
		var contentRatio = contentRange / totalScrollRange;

		// Snap points for discrete column stops
		var snapPoints = cols.map(function (_, i) {
			return cols.length === 1 ? 0 : (i / (cols.length - 1)) * contentRatio;
		});
		snapPoints.push(1);

		// --- Lottie scrub variables (shared with the pin's onUpdate) ---
		var lottieReady = false;
		var lottieTotalFrames = 0;
		var lottieTargetFrame = 0;
		var lottieCurrentFrame = 0;
		var lottieRafId = null;
		var LERP = 0.12;
		var THRESHOLD = 0.5;

		function lottieTick() {
			lottieCurrentFrame += (lottieTargetFrame - lottieCurrentFrame) * LERP;
			var clamped = Math.max(
				0,
				Math.min(lottieTotalFrames - 1, lottieCurrentFrame),
			);
			if (
				Math.abs(clamped - lottiePlayer.getLottie().currentFrame) > THRESHOLD
			) {
				lottiePlayer.seek(Math.round(clamped));
			}
			if (Math.abs(lottieTargetFrame - lottieCurrentFrame) > THRESHOLD) {
				lottieRafId = requestAnimationFrame(lottieTick);
			} else {
				lottieRafId = null;
			}
		}

		function lottiEnsureLoop() {
			if (!lottieRafId) lottieRafId = requestAnimationFrame(lottieTick);
		}

		if (isLottie) {
			lottiePlayer.addEventListener("ready", function () {
				lottiePlayer.pause();
				lottiePlayer.seek(0);
				lottieTotalFrames = lottiePlayer.getLottie().totalFrames;
				if (lottieTotalFrames) lottieReady = true;
			});
		}

		// --- Pinned ScrollTrigger: drives both column cycling + lottie scrub ---
		ScrollTrigger.create({
			trigger: section,
			pin: true,
			start: "center center",
			end: "+=" + totalScrollRange,
			snap: {
				snapTo: snapPoints,
				duration: { min: 0.3, max: 0.6 },
				ease: "power1.inOut",
			},
			onUpdate: function (self) {
				// Column cycling — progress mapped within content portion only
				var p = Math.min(self.progress / contentRatio, 1);
				var idx = Math.round(p * (cols.length - 1));
				showColumn(idx);

				// Lottie seeking — complete playback by end of content range
				if (lottieReady) {
					lottieTargetFrame = p * (lottieTotalFrames - 1);
					lottiEnsureLoop();
				}
			},
			onLeave: function () {
				if (lottieReady) {
					lottieTargetFrame = lottieTotalFrames - 1;
					lottieCurrentFrame = lottieTotalFrames - 1;
					lottiePlayer.seek(lottieTotalFrames - 1);
					if (lottieRafId) {
						cancelAnimationFrame(lottieRafId);
						lottieRafId = null;
					}
				}
			},
			onLeaveBack: function () {
				if (lottieReady) {
					lottieTargetFrame = 0;
					lottieCurrentFrame = 0;
					lottiePlayer.seek(0);
					if (lottieRafId) {
						cancelAnimationFrame(lottieRafId);
						lottieRafId = null;
					}
				}
			},
		});

		// --- Exploded illustration: component drift on scroll (unchanged) ---
		var isMobile = window.matchMedia("(max-width: 749px)").matches;
		var components = section.querySelectorAll(".isp-exploded__component");

		if (!isMobile && components.length > 0) {
			components.forEach(function (el) {
				var dx = parseFloat(el.getAttribute("data-drift-x") || 0);
				var dy = parseFloat(el.getAttribute("data-drift-y") || 0);
				gsap.fromTo(
					el,
					{ x: 0, y: 0 },
					{
						x: dx,
						y: dy,
						ease: "none",
						scrollTrigger: {
							trigger: section,
							start: "top bottom",
							end: "center center",
							scrub: true,
						},
					},
				);
			});
		}
	}

	function initFamily() {
		var section = document.querySelector(".isp-family");
		if (!section) return;

		var FAMILY_DURATION = 0.75; // slightly slower than global DURATION (0.55)
		var FAMILY_STAGGER = 0.15; // slightly slower than global STAGGER (0.1)

		// Background image: fade from black + zoom out (matches hero bg)
		var bgImage = section.querySelector(".isp-family__bg-image");
		if (bgImage) {
			gsap.set(bgImage, {
				autoAlpha: 0,
				scale: 1.08,
				transformOrigin: "center center",
			});
			gsap.to(bgImage, {
				autoAlpha: 1,
				scale: 1,
				duration: 1.5,
				ease: "power3.out",
				scrollTrigger: {
					trigger: section,
					start: "top 75%",
					toggleActions: TOGGLE,
				},
			});
		}

		// Headline, subhead, supporting text — each as its own stagger step
		var header = section.querySelector(".isp-family__header");
		if (header) {
			var headline = header.querySelector(".isp-family__headline");
			var subhead = header.querySelector(".isp-family__subhead");
			var supporting = header.querySelector(".isp-family__supporting");

			var textEls = [headline, subhead, supporting].filter(Boolean);
			if (textEls.length) {
				gsap.from(textEls, {
					opacity: 0,
					y: 80,
					duration: FAMILY_DURATION,
					ease: EASE,
					stagger: FAMILY_STAGGER,
					scrollTrigger: {
						trigger: header,
						start: START,
						toggleActions: TOGGLE,
					},
				});
			}
		}

		// Benefit cards
		var cards = section.querySelectorAll(".isp-family__card");
		if (cards.length) {
			gsap.from(cards, {
				opacity: 0,
				y: 80,
				duration: FAMILY_DURATION,
				ease: EASE,
				stagger: FAMILY_STAGGER,
				scrollTrigger: {
					trigger: section.querySelector(".isp-family__cards"),
					start: START,
					toggleActions: TOGGLE,
				},
			});
		}
	}

	function initHero() {
		var section = document.querySelector(".isp-header-hero");
		if (!section) return;

		var logo = section.querySelector(
			".isp-nav-header__logo, .isp-nav-header__site-name",
		);
		var bgImgs = section.querySelectorAll(".isp-hero__bg-img");
		var headline = section.querySelector(".isp-hero__headline");
		var subhead = section.querySelector(".isp-hero__subhead");
		var banner = section.querySelector(".isp-banner");

		// Set initial states before first paint to avoid flash
		if (logo) gsap.set(logo, { autoAlpha: 0 });
		if (bgImgs.length)
			gsap.set(bgImgs, {
				autoAlpha: 0,
				scale: 1.08,
				transformOrigin: "center center",
			});
		if (subhead) gsap.set(subhead, { autoAlpha: 0, y: 80 });

		var tl = gsap.timeline({ delay: 0.15 });

		// 1. Logo fades in
		if (logo) {
			tl.to(logo, { autoAlpha: 1, duration: 2, ease: "power3.out" });
		}

		// 2. BG image fades from black, scale 1.08 → 1
		if (bgImgs.length) {
			tl.to(
				bgImgs,
				{ autoAlpha: 1, scale: 1, duration: 1.5, ease: "power3.out" },
				"<0.6",
			);
		}

		// 3. Headline: per-line stagger fade-up (SplitText, responsive)
		if (headline) {
			SplitText.create(headline, {
				type: "lines",
				linesClass: "isp-split-line",
				autoSplit: true,
				onSplit: function (self) {
					gsap.set(headline, { autoAlpha: 1 });
					return gsap.from(self.lines, {
						autoAlpha: 0,
						y: 80,
						duration: 0.8,
						ease: "power3.out",
						stagger: { each: 0.15 },
					});
				},
			});
		}

		// 4. Subheading fades up
		if (subhead) {
			tl.to(
				subhead,
				{ autoAlpha: 1, y: 0, duration: 0.8, ease: "power3.out" },
				"-=0.6",
			);
		}

		// Parallax: bg images drift down at ~60% of scroll speed as the hero exits
		if (!IS_MOBILE && bgImgs.length) {
			gsap.to(bgImgs, {
				y: "20%",
				ease: "none",
				scrollTrigger: {
					trigger: section,
					start: "top top",
					end: "bottom top",
					scrub: true,
				},
			});
		}

		var siteHeader = document.getElementById("HeaderWrapper");
		var isMobileBanner = window.matchMedia("(max-width: 767px)").matches;

		if (banner && siteHeader && !isMobileBanner) {
			// Desktop only: move banner into the site header so the GSAP pin works
			// from the correct DOM context.
			siteHeader.appendChild(banner);
		}

		if (banner) {
			if (isMobileBanner) {
				// Mobile: leave banner in its original in-hero position.
				// ScrollSmoother is disabled on mobile so we avoid GSAP pin entirely.
				// Instead, use onEnter/onLeaveBack to manually apply position:fixed
				// once the banner scrolls to the top of the viewport, with a placeholder
				// to prevent layout jump.
				var bannerH = banner.offsetHeight;
				var placeholder = document.createElement("div");
				placeholder.style.height = bannerH + "px";
				placeholder.style.display = "none";
				banner.parentNode.insertBefore(placeholder, banner);

				ScrollTrigger.create({
					trigger: banner,
					start: "top top",
					endTrigger: ".isp-footer",
					end: "bottom top",
					onEnter: function () {
						placeholder.style.display = "block";
						banner.style.position = "fixed";
						// Use safe-area-inset-top on iOS to avoid bleeding under the status bar
						banner.style.top = "env(safe-area-inset-top, 0px)";
						banner.style.left = "0";
						banner.style.width = "100%";
						banner.style.zIndex = "2";
					},
					onLeaveBack: function () {
						banner.style.position = "";
						banner.style.top = "";
						banner.style.left = "";
						banner.style.width = "";
						placeholder.style.display = "none";
					},
				});
			} else {
				ScrollTrigger.create({
					trigger: banner,
					start: "top top",
					pin: true,
					pinSpacing: false,
					endTrigger: ".isp-footer",
					end: "+=999999", // effectively "forever" to keep it pinned until the end of the page
				});
			}
		}
	}

	function initSmoothScroll() {
		if (window.matchMedia("(max-width: 1024px)").matches) return;
		if (typeof ScrollSmoother === "undefined") return;
		var wrapper = document.getElementById("PageContainer");
		var content = wrapper && wrapper.querySelector(".transition-body");
		if (!wrapper || !content) return;
		try {
			gsap.registerPlugin(ScrollSmoother);
			ScrollSmoother.create({
				wrapper: wrapper,
				content: content,
				smooth: 2.5,
				effects: true,
			});
		} catch (e) {
			console.warn("[ISP] ScrollSmoother init failed:", e);
		}
	}

	function init() {
		initSmoothScroll();
		initHero();
		initStatsNeeds();
		initReveals();
		initProductFeatures();
		initFamily();
		initCta();
		initTechnology();
		initTechnologyOrbs();
		initPlatforms();

		// Recalculate all trigger positions after images/fonts finish loading.
		// Lazy images above pinned sections can shift layout and cause stale
		// start/end measurements when only DOMContentLoaded is relied upon.
		if (document.readyState === "complete") {
			ScrollTrigger.refresh();
		} else {
			window.addEventListener("load", function () {
				ScrollTrigger.refresh();
			});
		}
	}

	var resizeTimer;
	window.addEventListener("resize", function () {
		clearTimeout(resizeTimer);
		resizeTimer = setTimeout(function () {
			ScrollTrigger.refresh();
		}, 200);
	});

	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", init);
	} else {
		init();
	}
})();
